<template>
  <div class="list-view product-checkout mt-0">

    <!-- Products List -->
    <stock-view-release-product-step-cart-products />

    <!-- Checkout Options -->
    <div class="checkout-options">
      <b-card>
        <hr>
        <div class="price-details">
          <b-button
              block
              variant="primary"
              @click="$emit('next-step')"
          >
            Poursuivre la Planification
            <feather-icon
                class="ml-50"
                icon="ArrowRightIcon"
            />
          </b-button>
        </div>

      </b-card>
    </div>
  </div>
</template>

<script>
import {BButton, BCard} from 'bootstrap-vue'
import StockViewReleaseProductStepCartProducts from './StockViewReleaseProductStepCartProducts.vue'

export default {
  components: {
    BButton,
    BCard,
    StockViewReleaseProductStepCartProducts,
  },
}
</script>
